import { withTranslation } from "next-i18next";
import isPaymentMethodValid from "@utils/isPaymentMethodValid";
import Link from "@components/core/Link";
import { useCurrentUser, useSubscriptionStatus } from "@hooks/use-current-user";
import { subscriptionStatuses } from "@utils/constants/subscriptionStatuses";

const WarningRibbon = ({ t }) => {
  const user = useCurrentUser();
  const subscriptionStatus = useSubscriptionStatus();

  const paymentMethodValid = isPaymentMethodValid(user?.default_payment_method);

  const warningText = () => {
    switch (subscriptionStatus) {
      case subscriptionStatuses.pastDueWaitingForPause:
        return t("common:navbar.failed_invoices_warning.past_due_waiting_for_pause");
      case subscriptionStatuses.pastDueWaitingForCancelation:
        return t("common:navbar.failed_invoices_warning.past_due_waiting_for_cancelation");
      case subscriptionStatuses.pastDue:
        return t("common:navbar.failed_invoices_warning.past_due");
      default:
        if (!paymentMethodValid) {
          return t("common:navbar.credit_card_warning");
        }

        return "";
    }
  };

  if (!user || user.state === "lead") return null;
  if (["trialing", "active"].includes(user.subscription?.state) && paymentMethodValid) return null;

  if (["past_due"].includes(user.subscription?.state) || !paymentMethodValid) {
    return (
      <div
        className="bg-secondary d-flex justify-content-center align-items-center text-center position-relative px-4 py-2"
        style={{ minHeight: "2.5rem" }}
      >
        <Link
          className="mb-0 text-dark font-weight-normal line-height-sm"
          href={{
            pathname: "/profile/payment-method",
            query: {
              redirect: "/home",
            },
          }}
        >
          {warningText()}
        </Link>
      </div>
    );
  }

  return null;
};

export default withTranslation("common")(WarningRibbon);
